/**
 * Information for Clients – "customer-downloaded-pdf" tracking for Mixpanel via Elevar
 *
 * Fires when a customer clicks a PDF download button on the product tile
 * (page.information-for-clients / page.information-for-customer).
 * Pushes to window.ElevarDataLayer; Elevar forwards to Mixpanel if configured.
 *
 * Only loaded on the information-for-clients page (theme.vet.liquid).
 */
(function () {
  if (!document.body.classList.contains('page-information-for-clients')) return;

  function getPdfId(link) {
    const blockEl = link.closest('[id^="shopify-block-"]');
    return (blockEl && blockEl.id) || link.href || 'unknown';
  }

  function getProductLabel(link) {
    const tile = link.closest('.generic-blocks__inner [class*="stack"]');
    if (!tile) return null;
    const richtext = tile.querySelector('[class*="richtext"] p');
    return richtext ? richtext.textContent.trim() : null;
  }

  function pushCustomerDownloadedPdf(link) {
    const pdfUrl = link.href || null;
    const pdfId = getPdfId(link);
    const product_label = getProductLabel(link);
    const payload = {
      event: 'customer-downloaded-pdf',
      page: 'information-for-clients',
      pdf_url: pdfUrl,
      pdf_id: pdfId,
      product_label: product_label
    };

    if (typeof window.ElevarDataLayer !== 'undefined' && Array.isArray(window.ElevarDataLayer)) {
      window.ElevarDataLayer.push(payload);
    }
    if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
  }

  function init() {
    const main = document.getElementById('MainContent');
    if (!main) return;

    const pdfLinks = main.querySelectorAll('a[download], a[href*=".pdf"]');
    pdfLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        pushCustomerDownloadedPdf(link);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
